// 全局基础样式
import '~/styles/index.less';
// 全局代理
import './proxy';
// 性能监控
import './faro';

import PageProvider from './PageProvider';

/**
 * 所有页面都需要执行的初始化逻辑
 */
export default PageProvider;
